<script setup>
import {computed, ref, useAttrs} from "vue";
import EditToggleButton from "../../Pub/components/EditToggleButton.vue";
import ResourceFileUpload from "../../../app/resources-builder/resources/ResourceFileUpload.vue";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import AddImageButton from "../../Pub/components/AddImageButton.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    resourceContent: {
        type: Object,
        required: true,
    },
    resourceImagePath: {
        type: String,
        required: true,
    },
    imgClass: {
        type: String,
        default: '',
    },
    imgName: {
        type: String,
        required: true
    },
    showAddImageButton: {
        type: Boolean,
        default: false
    }
});

const isEditing = ref(false);
const hoverActive = ref(false);

const attrs = useAttrs()

const resourceFilePath = computed({
    get() {
        const result = getNestedProperty(props.resourceContent, props.resourceImagePath);
        return result === undefined || result === null ? {} : result;
    },
    set(value) {
        setNestedProperty(props.resourceContent, props.resourceImagePath, value);
    }
});

function getNestedProperty(obj, path) {
    return path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : null), obj);
}

function setNestedProperty(obj, path, value) {
    const keys = path.split('.');
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) current[key] = {};
        current = current[key];
    }

    current[keys[keys.length - 1]] = value;
}

const shouldShowAddImageButton = computed(() => {
    return portalContentAndDesignStore.liveDesignerEnabled
        && !isEditing.value
        && !resourceFilePath.value['url']
        && props.showAddImageButton;
});

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}
</script>

<template>
<add-image-button
    v-if="shouldShowAddImageButton"
    @click="isEditing = true"
/>
<div
    v-if="resourceFilePath['url'] || isEditing"
    class="relative"
    @mouseenter="hoverActive = true"
    @mouseleave="hoverActive = false"
>
    <edit-toggle-button
        v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
        :is-editing="isEditing"
        @toggle="toggleEdit"
        class="transition-opacity duration-200"
    />

    <img v-if="!isEditing"
        :src="resourceFilePath['url']"
        v-bind="attrs"
        :class="imgClass"
        alt=""
    />

    <ResourceFileUpload
        v-else
        :unique_id="resourceContent.unique_id"
        :data="resourceFilePath"
        accept="image/*"
        title="Image"
        :name="imgName"
        no_src="/images/upload-image.png"
        @uploaded="(data) => resourceFilePath = data"
        @deleted="(data) => resourceFilePath = data"
    ></ResourceFileUpload>
</div>
</template>
